import React from "react";
import { MapActions } from "./Map.action";
import { MapState } from "./Map.state";

export const MapReducer: React.Reducer<MapState, MapActions> = (
  state,
  action
) => {
  switch (action.type) {
    case "MAP/CHANGE":
      return {
        ...state,
        mapRef: action.value
      };
    case "MAP/FILTER/CHANGE":
      return {
        ...state,
        regionalOperationCenter: action.value
      };
    case "MAP/LOCATIONS/CHANGE":
      return {
        ...state,
        locations: action.value
      };
    case "MAP/LOCATION/SELECT":
      return {
        ...state,
        selectedLocation: action.value
      };
    case "MAP/QUERY/CHANGE":
      return {
        ...state,
        query: action.value
      };
    case "MAP/REFRESH":
      return {
        ...state,
        query: null,
        regionalOperationCenter: false,
        selectedLocation: null
      };
    default:
      return state;
  }
};
